import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { teamUpdateTeamMemberStatus } from "backend/api/team.service";
import { MessageType } from "backend/model/messageType";
import { TeamMemberStatus } from "backend/model/teamMemberStatus";
import { USER_MEMBER_FIRM_ID_KEY } from "src/app/classic/classic-interceptor";

@Injectable({
  providedIn: "root",
})
export class WorkspaceListNavigationService {
  private readonly httpClient = inject(HttpClient);

  lastEngagementIdNavigatedTo: string | undefined;

  async updateTeamMemberStatus(
    engagementId: string,
    status: TeamMemberStatus,
    hostMemberFirmId: number,
  ): Promise<string | undefined> {
    sessionStorage.setItem(USER_MEMBER_FIRM_ID_KEY, `${hostMemberFirmId}`);

    try {
      const result = await teamUpdateTeamMemberStatus(this.httpClient, {
        request: {
          engagementId,
          status,
          hostMemberFirmId,
          canModifyEngagementAfterArchive: true,
          canAllowGuestRole: true,
        },
      });
      const failureMessage = result?.messages.find(
        (x) => x.messageType === MessageType.Error,
      );
      if (failureMessage) {
        return failureMessage.code;
      } else {
        return undefined;
      }
    } catch (error: unknown) {
      return "UnknownError";
    }
  }
}
